import actions from '../../actionTypes';

export default category => {
  return {
    type: actions.REMOVE_CATEGORY,
    category
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/removeCategory.js